import { getSystemList,historybyperson } from "./actions"

const getters = {

    getMD5List(state) {
        return state.taskMD5List
    },
    getAuths(state) {
        return state.userInfo.auths
    },
    getuserInfo(state) {
        return state.userInfo
    },
    getisDownLoadM(state){
        return state.isDownLoadM
    },

}

export default getters


